import { ArcGisMapConfig } from "../models/ArcGisMapConfig";
import Map from "./Map";
import Point from "@arcgis/core/geometry/Point";

interface Props {
    longitude: number;
    latitude: number;
    webMapItemId?: string;
    arcgisToken?: string;
}

const LocationViewer = ({ longitude, latitude, webMapItemId, arcgisToken }: Props) => {
    const mapConfig = {
        authAppId: process.env.REACT_APP_ARCGIS_APP_ID,
        portalUrl: process.env.REACT_APP_ARCGIS_PORTAL_URL,
    } as ArcGisMapConfig;

    const point = new Point({
        latitude,
        longitude,
    });

    return (
        <Map
            mapConfig={mapConfig}
            webMapItemId={webMapItemId}
            token={arcgisToken}
            center={point}
            items={[{ geometry: point }]}
        ></Map>
    );
};

export default LocationViewer;
